export const OFERTA_LINK = "https://gram.ax/resources/gx-legal/docs/oferta";
